module.exports = __webpack_public_path__ + "img/integrate.1fd86472.svg";